import { useState } from 'react';

export function useStepper() {
  const [step, setStep] = useState(0);
  const [direction, setDirection] = useState(null); // LMS → AP or AP → LMS

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  return {
    step,
    direction,
    setDirection,
    selectedCourse,
    setSelectedCourse,
    selectedTopics,
    setSelectedTopics,
    selectedStudents,
    setSelectedStudents,
    goNext: () => setStep((s) => s + 1),
    goBack: () => setStep((s) => s - 1),
    resetStepper: () => {
      setStep(0);
      setDirection(null);
      setSelectedCourse(null);
      setSelectedTopics([]);
      setSelectedStudents([]);
    },
  };
}
